import { api, ApiRequestConfig } from './api';

export type LogoutParams = {
  postLogoutRedirectUri: string;
};

export const logout = (config: ApiRequestConfig, data: LogoutParams) =>
  api.post('/identity/logout', data, config);
